import {Endpoints} from '../../../../../../../../../globals/api/endpoints';

export class CustomImagesEndpoints extends Endpoints {

  public static readonly IMAGE_POINT_FILES = CustomImagesEndpoints.VIEWER + '/file/custom-point-image';
  public static readonly IMAGE_POINT_FILE = CustomImagesEndpoints.IMAGE_POINT_FILES + '/' + CustomImagesEndpoints.FILE_ID;
}
